import { render } from "./viewLessonDiscuss.vue?vue&type=template&id=7a3d095a&scoped=true"
import script from "./viewLessonDiscuss.vue?vue&type=script&lang=js"
export * from "./viewLessonDiscuss.vue?vue&type=script&lang=js"

import "./viewLessonDiscuss.vue?vue&type=style&index=0&id=7a3d095a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3d095a"]])

export default __exports__